import axios from './axios.service';
import config from './../config';
import { getQueryStringFromObject, getRequestHeaders } from './common.service';

async function getComments(query=null) {
    let response;
    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/comments' + queryString, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function addComment(payload) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post(config.SERVER_BASE_URL + '/comments', payload, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

export {
    getComments,
    addComment
}
